import { useState } from "react";
import { Alert } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { isInBoxStyleLibraryEditor } from "@coreapp/utils/isInBoxStyleLibraryEditor";
import { GetWSMgr } from "@/Utils/StateLib";
import { useTopic } from "@/hooks/useTopic";

const BoxStyleEditorAlert = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <Alert severity="info" alertActions={{ closeAction: () => setDismissed(true) }}>
      {appstr("box layout editor pending changes banner")}
    </Alert>
  );
};

const BoxStyleEditorAlertWrapper = () => {
  // ModeSwitch fires on every BLE entry/exit; boxStylesPendingEditsChanged fires whenever an edit
  // is staged or cleared. Re-rendering on both ensures the banner flips on/off and, by unmounting
  // the inner component on exit, its dismissed state resets for the next session.
  const [, setTick] = useState(0);
  useTopic("ModeSwitch", () => setTick(n => n + 1));
  useTopic("boxStylesPendingEditsChanged", () => setTick(n => n + 1));

  const wsMgr = GetWSMgr();
  // Background-file BLE hides the box style library, so its staging banner doesn't apply there.
  if (!isInBoxStyleLibraryEditor(wsMgr)) return null;
  // The banner warns about unsaved staged edits (incl. pending copy/rename/delete); with nothing
  // staged there's nothing to warn about, so don't cover the canvas with it.
  if (!wsMgr?.GetBoxStylesMgr?.()?.HasAnyPendingChanges?.()) return null;

  return <BoxStyleEditorAlert />;
};

export default BoxStyleEditorAlertWrapper;
